export default __webpack_public_path__ + "static/media/coco_badge_3.b7d8a3db.svg";